import React from 'react';
import { Link } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';

const CarouselComponent = () => {
  const { user } = useAuth();
  
  return (
    <>
      <section className="fundisha-hero" aria-label="Fundisha landing hero">
        <div className="fundisha-hero-shape" aria-hidden="true"></div>
        <svg className="fundisha-hero-noise" aria-hidden="true" viewBox="0 0 1200 800" preserveAspectRatio="none">
          <defs>
            <pattern id="grain" width="160" height="160" patternUnits="userSpaceOnUse">
              <path d="M0 20h160M0 80h160M0 140h160" stroke="rgba(242,237,228,0.09)" strokeWidth="1" />
              <path d="M30 0v160M90 0v160M150 0v160" stroke="rgba(245,166,35,0.08)" strokeWidth="1" />
            </pattern>
          </defs>
          <rect width="100%" height="100%" fill="url(#grain)"></rect>
        </svg>

        <div className="fundisha-hero-grid">
          <p className="fundisha-kicker fundisha-load-in fundisha-delay-1">Afro-futurist learning studio</p>
          <h1 className="fundisha-hero-title fundisha-load-in fundisha-delay-2">
            Learn without <em>limits.</em>
            <br />
            Teach with <em>purpose.</em>
          </h1>
          <p className="fundisha-hero-sub fundisha-load-in fundisha-delay-2">
            Fundisha helps African learners and educators build practical digital skills with creative confidence.
          </p>
          <div className="fundisha-hero-actions fundisha-load-in fundisha-delay-3">
            <Link to="/courses" className="fundisha-btn-primary">Explore Courses</Link>
            {user ? (
              <Link to="/dashboard" className="fundisha-btn-ghost">Open Dashboard</Link>
            ) : (
              <Link to="/auth" className="fundisha-btn-ghost">Start Learning</Link>
            )}
          </div>
        </div>
      </section>

      <div className="fundisha-stats-bar">
        <div className="fundisha-stats-wrap">
          <span className="fundisha-stat-chip">12,000+ Learners</span>
          <span className="fundisha-stat-chip">300+ Courses</span>
          <span className="fundisha-stat-chip">98% Completion Rate</span>
        </div>
      </div>
    </>
  );
};

export default CarouselComponent;